export interface SupportRequestReference {
    id: string;
    number: number;
}

export interface SupportPrefill {
    message: string | null;
    request: SupportRequestReference | null;
}

/** One-shot context passed to Support before navigation. */
let pendingPrefill: SupportPrefill = { message: null, request: null };

export const setSupportPrefill = (msg: string): void => {
    pendingPrefill = { ...pendingPrefill, message: msg };
};

export const setSupportRequestReference = (request: SupportRequestReference): void => {
    pendingPrefill = { ...pendingPrefill, request };
};

export const consumeSupportPrefill = (): SupportPrefill => {
    const value = pendingPrefill;
    pendingPrefill = { message: null, request: null };
    return value;
};
